module.exports = __webpack_public_path__ + "img/napa_green_land.cf396a80.jpg";